import React, { Component } from "react";
import "antd/dist/antd.css";
import jsPDF from "jspdf";
// import moment from 'moment';
import "jspdf-autotable";
// import Appconfig from '../../Config/AppConfig';
// Date Fns is used to format the dates we receive
// from our API call
// import { format } from "date-fns";
import { DownloadOutlined } from "@ant-design/icons";
// import logo from '../Images/org.png';
import logo from "../Images/pdf_logo.png";
import invoice from "../Images/invoice.png";

import phoneIcon from "../Images/phone.jpg";
import mailIcon from "../Images/mail.png";
import {
  formatPhoneNumber,
  formatPhoneNumber1,
} from "../Containers/commonFunctions";
import { getDetails } from "../api/Apis";
import { getOraganizationDetails } from "../api/OraganizationApis";

import AppConfigs from "../Config/AppConfig";

function getCustomerDetails(customerId) {
  return getDetails(
    AppConfigs["entityNames"]["registrations"],
    customerId
  ).then(async (customerRes) => {
    if (customerRes.success) {
      return customerRes.data;
    } else {
      console.log(customerRes.errors);
      // this.setState({
      //     dataLoadingStatus: false
      // })
    }
  });
}

async function getOrgDetails(orgId) {
  let organization = await getOraganizationDetails(orgId);
  console.log(organization);
  return organization.data;
}

class GeneratePdf extends Component {
  generatePDF = async () => {
    this.props.startLoading();
    const doc = new jsPDF();
    doc.setFontSize(10);
    let leadsDetails = this.props.leadData;
    let customerInfo = await getCustomerDetails(leadsDetails["customerId"]);
    let carrierInfo = "";
    if (leadsDetails["carrierId"]) {
      carrierInfo = await getCustomerDetails(leadsDetails["carrierId"]);
    }

    // let org = await getOrgDetails(leadsDetails["orgId"])
    doc.setLineWidth(1);
    // const orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
    const orgDetails = await getOrgDetails(leadsDetails["orgId"]);
    // JSON.parse(localStorage.getItem("orgDetails"));

    doc.addImage(logo, "png", 10, 18, 30, 20);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    // if (this.props.callFrom === "orders") {
    doc.text(orgDetails["orgName"], 50, 22);
    // } else {
    //     doc.text(orgDetails["companyName"], 160, 20);
    // }
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    let splitTitle = doc.splitTextToSize(orgDetails["address"], 50);
    doc.text(splitTitle, 50, 27);
    let phoneNumber = orgDetails["phone"]
      ? formatPhoneNumber(orgDetails["phone"])
      : "";
    doc.text(phoneNumber, 50, 37);

    doc.setFont("helvetica", "bold");
    doc.text("BILL OF LADING", 170, 22);
    // console.log("load Details", leadsDetails);

    // doc.text(orgDetails["address"], 120, 28);
    // let customerAddress = "address" in orgDetails ? orgDetails["address"].split(",") : "";
    // let customerLocation = "", customerCity = "";
    // if(customerAddress) {
    //     customerLocation = customerAddress.slice(",", 3).join(",");
    //     customerAddress.splice(0,3)
    //     customerCity = customerAddress.join(",");
    // }
    // // doc.text(customerAddress, 120, 28);
    // doc.text(customerLocation, 100, 28);
    // doc.text(customerCity, 100, 38);
    doc.line(10, 50, 200, 50);

    doc.setFont("helvetica", "bold");
    doc.setFontSize(15);
    // doc.text('Load No: ' + leadsDetails["orderId"], 90, 60);
    doc.text("Load No: " + leadsDetails["subOrderId"], 90, 60);
    doc.setFontSize(10);
    let carrierName = "",
      driverName = "",
      carrierPhone = "",
      carrierEmail = "",
      truckNumber = "";

    if (
      leadsDetails["orderStatus"] === "I" ||
      leadsDetails["orderStatus"] === "D" ||
      leadsDetails["orderStatus"] === "AC"
    ) {
      carrierName =
        "carrierDetails" in leadsDetails
          ? leadsDetails["carrierDetails"]["carrierName"]
          : "";
      driverName =
        "driverDetails" in leadsDetails && leadsDetails["driverDetails"]["name"]
          ? leadsDetails["driverDetails"]["name"]
          : "";
      carrierPhone =
        "carrierDetails" in leadsDetails &&
        carrierInfo["phone"] &&
        carrierInfo["phone"].length === 10
          ? formatPhoneNumber(carrierInfo["phone"])
          : carrierInfo["phone"]
          ? formatPhoneNumber1(carrierInfo["phone"])
          : "";
      carrierEmail =
        "carrierDetails" in leadsDetails ? carrierInfo["email"] : "";
      // truckNumber = "driverDetails" in leadsDetails && leadsDetails["driverDetails"] && leadsDetails["driverDetails"]["truckNumber"] ? leadsDetails["driverDetails"]["truckNumber"] : leadsDetails["truckDetails"]["truckNumber"];
      truckNumber =
        "driverDetails" in leadsDetails && leadsDetails["driverDetails"]
          ? (leadsDetails["driverDetails"] &&
              leadsDetails["driverDetails"]["truckNumber"]) ||
            (leadsDetails["truckDetails"] &&
              leadsDetails["truckDetails"]["truckNumber"]) ||
            leadsDetails["truckNumber"]
          : "";
    }

    if (
      leadsDetails["orderStatus"] === "AC" ||
      leadsDetails["orderStatus"] === "PC"
    ) {
      truckNumber =
        "truckDetails" in leadsDetails &&
        Object.keys(leadsDetails["truckDetails"]).length !== 0
          ? leadsDetails["truckDetails"]["truckNumber"] &&
            leadsDetails["truckDetails"]["truckNumber"]
          : "";
    }

    doc.setLineWidth(0.5);
    doc.rect(10, 75, 190, 35);
    doc.text("Carrier Details", 10, 71);
    doc.text("Name: ", 15, 82);
    doc.setFont("helvetica", "", "normal");
    doc.setFontSize(11);
    doc.text(carrierName, 28, 82);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    // let driverName =
    //   "driverDetails" in leadsDetails && leadsDetails["driverDetails"]["name"]
    //     ? leadsDetails["driverDetails"]["name"]
    //     : "";

    doc.text("Driver Name: ", 15, 90);
    doc.setFont("helvetica", "", "normal");
    doc.setFontSize(11);
    doc.text(driverName, 38, 90);
    // let truckNumber = "truckDetails" in leadsDetails && leadsDetails["truckDetails"] ? (leadsDetails["driverDetails"]["truckNumber"] ? leadsDetails["driverDetails"]["truckNumber"]  || leadsDetails["truckDetails"]["truckNumber"] : "") : "";
    // let truckNumber = "truckNumber" in leadsDetails && leadsDetails["truckNumber"] ? leadsDetails["truckNumber"] : "";
    // let truckNumber =   "driverDetails" in leadsDetails ? leadsDetails["driverDetails"]["truckNumber"] || leadsDetails["truckDetails"]["truckNumber"] : ""

    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text("Truck Number: ", 143, 90);
    doc.setFont("helvetica", "", "normal");
    doc.setFontSize(11);
    doc.text(truckNumber, 170, 90);
    doc.setFontSize(10);
    doc.addImage(phoneIcon, "jpg", 15, 95, 4, 4);
    doc.setFontSize(11);
    doc.text(carrierPhone, 23, 99);
    doc.addImage(mailIcon, "png", 128, 96, 5, 5);
    doc.setFontSize(12);
    doc.text(carrierEmail, 135, 99);

    // if (this.props.callFrom === "carriers") {
    let mc = carrierInfo["mc"] ? carrierInfo["mc"] : "";
    let dot = carrierInfo["dot"] ? carrierInfo["dot"] : "";
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text("MC #", 15, 106);
    doc.setFont("helvetica", "", "normal");
    doc.text(mc, 25, 106);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text("DOT #", 158, 106);
    doc.setFont("helvetica", "", "normal");
    doc.text(dot, 170, 106);
    // }

    doc.setFont("helvetica", "bold");
    doc.rect(10, 125, 190, 35);
    doc.text("Load Details", 10, 120);
    doc.addFont("../Fonts/Roboto/Roboto-Thin.ttf", "Roboto", "normal");
    doc.text("Product Name: ", 15, 132);
    doc.setFont("Roboto", "normal");
    doc.setFontSize(11);
    let productName = leadsDetails["productName"];
    let po = leadsDetails["poNumber"] ? leadsDetails["poNumber"] : "";
    let quantity = leadsDetails["quantity"];
    let size = leadsDetails["size"];
    doc.text(productName, 42, 132);
    doc.setFontSize(10);
    // doc.save(`Load_Details_${leadsDetails.orderId}.pdf`);
    // doc.text('Product Name: ' + leadsDetails["productName"], 15, 132);
    doc.setFont("helvetica", "bold");
    // doc.text('Customer Name: '+leadsDetails["customerName"], 15, 148);
    // doc.text("PO#: ", +po, 15, 142);
    doc.setFont("Roboto", "normal");
    doc.text(po, 25, 142);
    // doc.text('Weight: ' + leadsDetails["size"], 15, 148);
    doc.setFont("helvetica", "bold");
    doc.text("Quantity: " + quantity, 77, 142);
    doc.setFont("Roboto", "normal");
    // doc.text(quantity, 77, 152);
    doc.setFont("helvetica", "bold");
    doc.text("Size: ", 150, 142);
    doc.setFont("Roboto", "normal");
    doc.text(size, 160, 142);
    doc.setFont("helvetica", "bold");
    doc.text("Type: ", 15, 150);
    doc.setFont("Roboto", "normal");
    doc.text(leadsDetails["measurementType"], 25, 150);
    doc.setFont("helvetica", "bold");
    doc.text("Truck: ", 77, 150);
    doc.setFont("Roboto", "normal");
    doc.text(leadsDetails["deliveryTruck"], 90, 150);

    // doc.text('Total: $' + leadsDetails["totalAmt"], 150, 158);
    doc.setFont("helvetica", "bold");
    doc.text("Miles: ", 150, 150);
    doc.setFont("Roboto", "normal");
    let dis = leadsDetails["distanceMiles"]
      ? leadsDetails["distanceMiles"]
      : "";
    doc.text(dis, 162, 150);

    // let truckNumber = "driverDetails" in leadsDetails ? leadsDetails["driverDetails"]["truckNumber"] : "";
    // doc.text('Truck #: '+truckNumber, 100, 168);

    let address =
      "productOriginDetails" in leadsDetails
        ? Array.isArray(leadsDetails["productOriginDetails"])
          ? leadsDetails["productOriginDetails"][0]["address"]
          : leadsDetails["productOriginDetails"]["address"]
        : "";
    // let location = "", city = "";
    // if (address) {
    //     location = address[0];
    //     address.splice(0, 1)
    //     city = address.join(",");
    // }
    let productLocationName =
      "productOriginDetails" in leadsDetails &&
      leadsDetails["productOriginDetails"]["locationName"]
        ? leadsDetails["productOriginDetails"]["locationName"]
        : "";

    doc.setFont("helvetica", "bold");
    doc.rect(10, 173, 190, 40);
    doc.text("Pickup Details", 10, 170);
    doc.setFont("helvetica", "normal");
    // doc.text(orgDetails["orgName"], 15, 193);
    doc.text(productLocationName, 15, 180);
    doc.setTextColor(74, 144, 204);
    let splitLocationTitle = doc.splitTextToSize(address, 50);
    doc.text(splitLocationTitle, 15, 190);

    // let splitCityTitle = doc.splitTextToSize(city, 50);
    // doc.text(splitCityTitle, 14, 200);
    doc.setTextColor(0, 0, 0);
    doc.text(
      leadsDetails["productOriginDetails"]["phone"]
        ? formatPhoneNumber(leadsDetails["productOriginDetails"]["phone"])
        : "",
      15,
      207
    );
    // doc.line(90, 185, 90, 225);
    doc.line(75, 173, 75, 213);

    let pickupDate =
      "pickupDate" in leadsDetails && leadsDetails["pickupDate"]
        ? leadsDetails["pickupDate"]
        : "";
    // let pickupTime = "pickupDate" in leadsDetails ? leadsDetails["pickupStartTime"] + " - " + leadsDetails["pickupEndTime"] : "";
    let pickupStartTime =
      "pickupStartTime" in leadsDetails && leadsDetails["pickupStartTime"]
        ? leadsDetails["pickupStartTime"] + " - "
        : "";
    let pickupEndTime =
      "pickupEndTime" in leadsDetails && leadsDetails["pickupEndTime"]
        ? leadsDetails["pickupEndTime"]
        : "";
    doc.setFont("helvetica", "bold");
    doc.text("Date: ", 77, 180);
    doc.setFont("helvetica", "normal");
    doc.text(pickupDate, 87, 180);
    // doc.text('Time: ' + pickupTime, 77, 196);
    doc.setFont("helvetica", "bold");
    doc.text("Time: ", 77, 190);
    doc.setFont("helvetica", "normal");
    doc.text(pickupStartTime, 87, 190);
    doc.text(pickupEndTime, 105, 190);

    doc.setFont("helvetica", "bold");
    // doc.text("Pickup #: ", 77, 200);
    doc.setFont("helvetica", "normal");
    doc.line(135, 173, 135, 213);

    let pickUpNotes = leadsDetails["cartItems"]?.[0]["defeoNotes"]
      ? leadsDetails["cartItems"]?.[0]["defeoNotes"]
      : "";
    let splitPickUpNotTitle = doc.splitTextToSize(pickUpNotes, 50);
    doc.setFont("helvetica", "bold");
    doc.text("Pickup Notes: ", 140, 180);
    doc.setFont("helvetica", "normal");
    doc.text(splitPickUpNotTitle, 140, 185);

    // if (this.props.callFrom === "carriers") {

    // let locationAddress = "cartItems" in leadsDetails ? leadsDetails["cartItems"][0]["address"].split(",") : "";
    let locationAddress =
      "cartItems" in leadsDetails
        ? leadsDetails["cartItems"][0]["address"]
        : "";

    // let destinationLocation = "", destinationCity = "";
    // if (locationAddress) {
    //     destinationLocation = locationAddress[0];
    //     locationAddress.splice(0, 1)
    //     destinationCity = locationAddress.join(",");
    // }
    let locationName =
      "cartItems" in leadsDetails &&
      leadsDetails["cartItems"][0]["locationName"]
        ? leadsDetails["cartItems"][0]["locationName"]
        : "";
    doc.setFont("helvetica", "bold");
    doc.rect(10, 225, 190, 40);
    doc.text("Destination Details", 10, 221);
    doc.setFont("helvetica", "normal");
    // doc.text(orgDetails["orgName"], 15, 242);
    doc.setFont("helvetica", "bold");
    doc.text(
      customerInfo && customerInfo["companyName"]
        ? customerInfo["companyName"]
        : "",
      15,
      232
    );
    doc.setFont("helvetica", "normal");
    doc.text(locationName, 15, 238);
    // doc.text(locationAddress, 15, 260);
    doc.setTextColor(74, 144, 205);

    let splitDestLocTitle = doc.splitTextToSize(locationAddress, 60);
    doc.text(splitDestLocTitle, 15, 245);

    // let splitDestCityTitle = doc.splitTextToSize(destinationCity, 50);
    // doc.text(splitDestCityTitle, 14, 245);
    doc.setTextColor(0, 0, 0);
    doc.text(
      customerInfo["phone"] ? formatPhoneNumber(customerInfo["phone"]) : "",
      15,
      260
    );
    doc.line(75, 225, 75, 265);

    let deliveryDateAndTime =
      "deliveryDateAndTime" in leadsDetails
        ? leadsDetails["deliveryDateAndTime"]
        : "";
    let deliveryDate = "";
    let deliveryTime = "";
    if (deliveryDateAndTime) {
      deliveryDate = deliveryDateAndTime.split(" ")[0];
      deliveryTime = deliveryDateAndTime.slice(11);
    }
    doc.setFont("helvetica", "bold");
    doc.text("Date: ", 77, 232);
    doc.setFont("helvetica", "normal");
    doc.text(deliveryDate, 87, 232);
    doc.setFont("helvetica", "bold");
    doc.text("Time: ", 77, 240);
    doc.setFont("helvetica", "normal");
    doc.text(deliveryTime, 87, 240);
    doc.setFont("helvetica", "bold");
    // doc.text("Delivery #: ", 77, 250);
    doc.line(135, 225, 135, 265);

    // doc.text('Delivery Notes: '+splitDestNotTitle , 138, 250);
    let destinationNotes =
      // leadsDetails["defeoNotes"]?leadsDetails["defeoNotes"]:"";
      "carrierDetails" in leadsDetails &&
      leadsDetails["carrierDetails"]["carrierNotes"]
        ? leadsDetails["carrierDetails"]["carrierNotes"]
        : "";
    let splitDestNotTitle = doc.splitTextToSize(destinationNotes, 50);

    doc.setFont("helvetica", "bold");
    doc.text("Delivery Notes: ", 138, 232);
    doc.setFont("helvetica", "normal");
    doc.text(splitDestNotTitle, 138, 238);

    doc.line(10, 283, 75, 283);
    doc.line(200, 283, 135, 283);

    doc.save(`BOL_${leadsDetails.orderId}.pdf`);
    this.props.stopLoading();
    // }
    // else {
    //     doc.setFont("helvetica", "bold");
    //     doc.text('Other Details', 10, 221);
    //     doc.setFont("helvetica", "normal");
    //     doc.rect(10, 225, 190, 45);
    //     let notes = "notes" in leadsDetails ? leadsDetails["notes"] : "";
    //     doc.text('Notes:', 15, 235);
    //     doc.text(notes, 28, 235)
    //     doc.save(`Load_Details_${leadsDetails.orderId}.pdf`);
    //     this.props.stopLoading();
    // }
  };

  toDataURL(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        callback(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.send();
  }

  render() {
    return (
      <main>
        {this.props.pathName === "loads" ? (
          <span
            className={this.props.pathname === "/app/loads" ? "order-pdf" : ""}
            onClick={() => {
              this.generatePDF();
            }}
          >
            Download BOL
          </span>
        ) : (
          ""
        )}
        {this.props.pathName === "loaddetails" ? (
          <h3 style={{ color: "#fff" }}>
            <span
              className="see-all-red cursor-card"
              onClick={() => this.generatePDF()}
            >
              <DownloadOutlined style={{ fontSize: "1.3em" }} />
              Download BOL
            </span>
          </h3>
        ) : (
          ""
        )}
        {this.props.pathName === "allOrders" ? (
          <span
            className={this.props.pathname === "/app/loads" ? "order-pdf" : ""}
            onClick={() => {
              this.generatePDF();
            }}
          >
            Download BOL
          </span>
        ) : (
          ""
        )}
        {this.props.pathName === "orderDetails" ? (
          <div>
            <span
              style={{ color: "#0E4D90", marginLeft: "5px" }}
              onClick={() => this.generatePDF()}
            >
              <img src={invoice} alt="invoice" />
              Bill of Lading
            </span>
          </div>
        ) : (
          ""
        )}
        {/* {   this.props.callFrom === "orders" ?
                        <span style={{ color: "rgba(0, 0, 0, 0.65)", cursor: "pointer" }} onClick={() => { this.generatePDF() }}>Download PDF</span>
                    :
                        <h3 style={{ color: '#fff' }}>
                            <span className='see-all-red cursor-card' onClick={() => this.generatePDF()}><DownloadOutlined style={{ fontSize: '1.3em' }} />Download PDF</span>
                        </h3>
                } */}
      </main>
    );
  }
}

export default GeneratePdf;
